export const usesQuantity = product => !product.isPrime && ["Placement", "Vacation"].includes(product.product);
export const pricingMultiplier = product => Number(usesQuantity(product) ? product.quantity ?? product.coefficient ?? 1 : product.coefficient ?? 0);
export const lineAmount = product => Number(product.taux || 0) * pricingMultiplier(product);
